import React, { useEffect, useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import s from './DPLink.scss';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

const event = new Event('dpLinkDataLoaded');
const dpandaURL =
  'https://app.dpanda.in/index.php?route=api/publisher/fetchAndFilterJson&key=';

const DPLinksData = {};
const getDpandaLinks = () => {
  const { location: { href = '' } = {} } = window;
  const [msidWithCms = ''] = href.match(/[\d]*.cms/);
  const [msid] = msidWithCms.split('.') || [];
  if (
    href.includes('life-style/health-fitness') &&
    Object.keys(DPLinksData).length < 1
  ) {
    fetch(`${dpandaURL}${msid}`)
      .then(res => res.json())
      .then((data = []) => {
        if (data.length > 0) {
          const [item = {}] = data;
          const { context: { inline = {} } = {} } = item;
          inline.forEach((keywordData = {}) => {
            const { text } = keywordData;
            DPLinksData[text] = keywordData;
          });
          document.dispatchEvent(event);
        }
      })
      .catch(e => {
        console.log('Error in fetching dpanda links data:', e);
      });
  }
};

if (typeof window !== 'undefined') {
  const { requestIdleCallback = setTimeout } = window;
  if (requestIdleCallback && Object.keys(DPLinksData).length < 1) {
    requestIdleCallback(() => {
      getDpandaLinks();
    });
  }
}

const scriptURL = 'https://times-network.dpanda-buy-widget.pages.dev/widget.js';

const getAttributeParams = attributes => {
  const keys = Object.keys(attributes);
  const result = {};
  keys.forEach((key = '') => {
    if (key === 'dpw-commerce' || key === 'class') {
      result[key] = attributes[key];
    } else {
      const chunk = key.split('-').slice(1);
      let str = '';
      if (chunk.length > 1) {
        chunk.forEach((item, i) => {
          str += i === 0 ? item : item.charAt(0).toUpperCase() + item.slice(1);
        });
      }
      result[str] = attributes[key];
    }
  });
  return result;
};

const Link = props => {
  const { data = {}, needLeftSpace } = props;
  const { text, attributes } = data;
  const [loading, setLoading] = useState(false);
  const [linkActive, setLinkActive] = useState(false);

  useEffect(() => {
    document.addEventListener('dpLinkDataLoaded', () => {
      setLinkActive(true);
    });
  }, []);

  const onClickAction = () => {
    const { DPWidget: { togglePDP } = {} } = window;
    const attrib = getAttributeParams(attributes);
    setLoading(false);
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'dpanda',
      label: text,
    });
    togglePDP(attrib, {
      config: {
        categoryToggle: true,
      },
    });
  };

  const loadDPandaScript = () => {
    const script = document.createElement('script');
    const body = document.getElementsByTagName('body')[0];
    script.src = scriptURL;
    window.dp_script = true;
    body.appendChild(script);
    script.addEventListener('load', () => {
      const { DPWidget: { togglePDP } = {} } = window;
      if (togglePDP) {
        onClickAction();
      }
    });
  };

  const onClick = () => {
    if (linkActive && DPLinksData[text]) {
      setLoading(true);
      if (window.dp_script) {
        onClickAction();
      } else {
        loadDPandaScript();
      }
    }
  };

  const clasName = cn({
    [s.main]: true,
    [s.link]: linkActive && DPLinksData[text] && true,
    [attributes?.class]: true,
    [s.loading]: loading,
    [s.ml8]: needLeftSpace,
  });

  return (
    <span onClick={onClick} className={clasName}>
      {text}
    </span>
  );
};

Link.propTypes = {
  data: PropTypes.shape({}),
  needLeftSpace: PropTypes.bool,
};

Link.defaultProps = { data: {}, needLeftSpace: false };

export default Link;
